<div class="block-schedule__bottom book-ride" *ngIf="(selectedTrip$ | async) === null">
    <h1>{{ 'ONDEMAND_TRIPS' | translate }}</h1>

    <p class="margin-bottom-40">{{ 'ONDEMAND_TRIPS_DESCRIPTION' | translate }}</p>

    <rwidget-empty-state [title]="'UPCOMING_TRIPS_EMPTY_TITLE'" [description]="'BOOKINGS_EMPTY_DESCRIPTION'"
        *ngIf="(loading$ | async) === false && (trips$ | async)?.length === 0" [icon]="emptySchedule">
        <a [routerLink]="'/book-a-ride' | localize" class="flex-center width-220 btn btn--primary btn--big link--no-line"
            tabindex="0">
            {{'HEADER_BOOK_RIDE' | translate}}
        </a>
    </rwidget-empty-state>

    <div class="trips" *ngFor="let trip of trips$ | async" (click)="select(trip)">
        <div class="trips-date last">
            <span>{{
                'LOCAL_CALENDAR_' + (trip.departure_timestamp | datex: 'dddd' | uppercase) + '_dddd' | translate
                }}</span>
            /
            <span>{{ trip.departure_timestamp | datex: dateFormat }}</span>
        </div>

        <div class="trips-wrapper">
            <div class="trips-stops-times">
                <div class="trips-stops-times__names">
                    <span class="trips-time">{{ trip.departure_timestamp | datex: 'HH:mm' }}</span>
                    <span class="circle big"></span>
                    <span class="">{{ trip.stops[0]?.address }}</span>
                </div>
                <div>
                    <div class="trips-line"></div>
                </div>
                <div class="trips-stops-times__names remove-margin">
                    <span class="trips-time">{{ trip.arrival_timestamp | datex: 'HH:mm' }}</span>
                    <span class="circle big"></span>
                    <span>{{ trip.stops[trip.stops.length-1]?.address }}</span>
                </div>
            </div>

            <a>
                <img src="assets/arrow.svg" alt="" />
            </a>
        </div>
    </div>
</div>

<div class="block-schedule__bottom book-ride" *ngIf="(selectedTrip$ | async)">
    <h1>{{ (selectedTrip$ | async)?.trip_short_name }}</h1>

    <ridango-ui-back-button (click)="back()">
        <span>{{ 'LOCAL_BTN_BACK' | translate }}</span>
    </ridango-ui-back-button>
    <div class="trips selected">
        <div class="trips-date" [ngClass]="{'last': !(selectedTrip$ | async).reg_number}">
            <span>{{
                'LOCAL_CALENDAR_' + ((selectedTrip$ | async).departure_timestamp | datex: 'dddd' | uppercase) +
                '_dddd' |
                translate
                }}</span>
            /
            <span>{{ (selectedTrip$ | async).departure_timestamp | datex: dateFormat }}</span>
        </div>

        <div class="trips-date last" *ngIf="(selectedTrip$ | async).reg_number">
            <span>{{ 'CAR_LICENSE_PLATE' | translate }}: {{ (selectedTrip$ | async).reg_number }}</span>
        </div>

        <div class="trips-wrapper">
            <div class="trips-stops-times">
                <div class="trips-stops-times__names"
                    *ngFor="let stop of (selectedTrip$ | async).stops; let first = first; let last = last;">
                    <span class="trips-time">{{ stop.arrival_timestamp | datex: 'HH:mm' }}</span>
                    <span class="circle" [ngClass]="{'big': first || last}"></span>
                    <span>{{ stop.address }}</span>
                    <span class="seats">
                        <mat-icon class="seats__icon">airline_seat_recline_normal</mat-icon>
                        <span class="seats__number" *ngIf="stop.seats_available">{{ stop.seats_available }}</span>
                        <span class="seats__number" *ngIf="!stop.seats_available">0</span>
                    </span>
                    <div *ngIf="!last" class="trips-line"></div>
                </div>
            </div>
        </div>
    </div>
</div>
